import { createApp } from 'vue'
import { VueFire, VueFireAuth } from 'vuefire'

import router from "./router"
import App from './App.vue'
import { firebaseApp } from './firebase'

const app = createApp(App);
app.use(VueFire, {
  // imported above but could also just be created here
  firebaseApp,
  modules: [
    // we will see other modules later on
    VueFireAuth(),
  ],
});
app.use(router);

app.mount('#app')
